// extracted by mini-css-extract-plugin
export default {"container":"HomePage_container__S-kOo","sidebar":"HomePage_sidebar__JZSeb","mainContent":"HomePage_mainContent__7Bynl"};